// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-js > video {
  display: none !important;
}
.video-js > .vjs-text-track-display {
  display: none !important;
}
.video-js {
  margin-top: -75px;
  z-index: -1;
}
`, "",{"version":3,"sources":["webpack://./src/pages/InteractiveVideo/components/video.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,WAAW;AACb","sourcesContent":[".video-js > video {\n  display: none !important;\n}\n.video-js > .vjs-text-track-display {\n  display: none !important;\n}\n.video-js {\n  margin-top: -75px;\n  z-index: -1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
